export const countries: Record<string, string> = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua And Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia And Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "BruneiDarussalam",
  BG: "Bulgaria",
  BF: "BurkinaFaso",
  BI: "Burundi",
  BQ: "Bonaire, Sint Eustatius and Saba",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos Keeling Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo Democratic Republic",
  CK: "Cook Islands",
  CR: "CostaRica",
  CI: "CoteDIvoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "ElSalvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island Mcdonald Islands",
  VA: "HolySeeVaticanCityState",
  HN: "Honduras",
  HK: "HongKong",
  HU: "Hungary",
  IC: "Canary Islands",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "IsleOfMan",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KR: "South Korea",
  KP: "North Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao Peoples Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "PuertoRico",
  QA: "Qatar",
  RE: "Reunion",
  MK: "Macedonia",
  MKD: "Republic Of North Macedonia",
  RO: "Romania",
  RU: "RussianFederation",
  RW: "Rwanda",
  BL: "SaintBarthelemy",
  SH: "SaintHelena",
  KN: "Saint Kitts And Nevis",
  LC: "SaintLucia",
  MF: "SaintMartin",
  PM: "SaintPierreAndMiquelon",
  VC: "Saint Vincent And Grenadines",
  WS: "Samoa",
  SM: "SanMarino",
  ST: "Sao Tome And Principe",
  SA: "SaudiArabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "SierraLeone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "SouthAfrica",
  GS: "South Georgia And Sandwich Island",
  ES: "Spain",
  LK: "SriLanka",
  SD: "Sudan",
  SS: "South Sudan",
  SR: "Suriname",
  SJ: "SvalbardAndJanMayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SX: "SintMaarten",
  SY: "SyrianArabRepublic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "TimorLeste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad And Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks And Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands British",
  VI: "Virgin Islands US",
  WF: "Wallis And Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const countriesWithPhoneCodes = [
  { id: "+1", name: "United States & Canada (+1)" },
  { id: "+44", name: "United Kingdom (+44)" },
  { id: "+49", name: "Germany (+49)" },
  { id: "+33", name: "France (+33)" },
  { id: "+34", name: "Spain (+34)" },
  { id: "+39", name: "Italy (+39)" },
  { id: "+7", name: "Russia (+7)" },
  { id: "+86", name: "China (+86)" },
  { id: "+91", name: "India (+91)" },
  { id: "+55", name: "Brazil (+55)" },
  { id: "+61", name: "Australia (+61)" },
  { id: "+81", name: "Japan (+81)" },
  { id: "+27", name: "South Africa (+27)" },
  { id: "+31", name: "Netherlands (+31)" },
  { id: "+32", name: "Belgium (+32)" },
  { id: "+47", name: "Norway (+47)" },
  { id: "+46", name: "Sweden (+46)" },
  { id: "+45", name: "Denmark (+45)" },
  { id: "+358", name: "Finland (+358)" },
  { id: "+351", name: "Portugal (+351)" },
  { id: "+30", name: "Greece (+30)" },
  { id: "+36", name: "Hungary (+36)" },
  { id: "+40", name: "Romania (+40)" },
  { id: "+41", name: "Switzerland (+41)" },
  { id: "+43", name: "Austria (+43)" },
  { id: "+48", name: "Poland (+48)" },
  { id: "+420", name: "Czech Republic (+420)" },
  { id: "+421", name: "Slovakia (+421)" },
  { id: "+423", name: "Liechtenstein (+423)" },
  { id: "+90", name: "Turkey (+90)" },
  { id: "+82", name: "South Korea (+82)" },
  { id: "+60", name: "Malaysia (+60)" },
  { id: "+65", name: "Singapore (+65)" },
  { id: "+66", name: "Thailand (+66)" },
  { id: "+63", name: "Philippines (+63)" },
  { id: "+64", name: "New Zealand (+64)" },
  { id: "+971", name: "United Arab Emirates (+971)" },
  { id: "+966", name: "Saudi Arabia (+966)" },
  { id: "+973", name: "Bahrain (+973)" },
  { id: "+972", name: "Israel (+972)" },
  { id: "+98", name: "Iran (+98)" },
  { id: "+962", name: "Jordan (+962)" },
  { id: "+964", name: "Iraq (+964)" },
  { id: "+20", name: "Egypt (+20)" },
  { id: "+212", name: "Morocco (+212)" },
  { id: "+213", name: "Algeria (+213)" },
  { id: "+216", name: "Tunisia (+216)" },
  { id: "+218", name: "Libya (+218)" },
  { id: "+221", name: "Senegal (+221)" },
  { id: "+223", name: "Mali (+223)" },
  { id: "+225", name: "Ivory Coast (+225)" },
  { id: "+227", name: "Niger (+227)" },
  { id: "+229", name: "Benin (+229)" },
  { id: "+233", name: "Ghana (+233)" },
  { id: "+234", name: "Nigeria (+234)" },
  { id: "+237", name: "Cameroon (+237)" },
  { id: "+239", name: "Sao Tome and Principe (+239)" },
  { id: "+241", name: "Gabon (+241)" },
  { id: "+243", name: "Democratic Republic of the Congo (+243)" },
  { id: "+244", name: "Angola (+244)" },
  { id: "+245", name: "Guinea-Bissau (+245)" },
  { id: "+248", name: "Seychelles (+248)" },
  { id: "+250", name: "Rwanda (+250)" },
  { id: "+251", name: "Ethiopia (+251)" },
  { id: "+253", name: "Djibouti (+253)" },
  { id: "+254", name: "Kenya (+254)" },
  { id: "+255", name: "Tanzania (+255)" },
  { id: "+256", name: "Uganda (+256)" },
  { id: "+257", name: "Burundi (+257)" },
];
export interface ICountriesOptions {
  id: string;
  name: string;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const countriesOptions: ICountriesOptions[] = Object.keys(
  countries
)?.map((countryKey) => ({
  id: countryKey,
  name: countries[countryKey],
}));
